import 'jquery.marquee';

const $ = jQuery;

$(function () {
    const $scrollLines = $('.scroll-line-element.is-animated, .scroll-line-element.animated');

    if (!$scrollLines.length || typeof $.fn.marquee !== 'function') {
        return;
    }

    $scrollLines.each(function () {
        const $el = $(this);

        // Prevent double init.
        if ($el.data('marquee-inited')) {
            return;
        }
        $el.data('marquee-inited', true);

        const duration = parseInt($el.data('duration'), 10) || 15000;
        const duplicateCount = parseInt($el.data('duplicate-count'), 10) || 6;

        $el.marquee({
            duration,
            gap: 3,
            delayBeforeStart: 0,
            direction: 'left',
            duplicated: true,
            duplicateCount,
            pauseOnHover: false,
            startVisible: true
        });
    });
});
